import { lazy, Suspense, useState, useEffect } from 'react';

const LoadableDelay = ({ fallback: F, delay }) => {
	const [showFallback, setShowFallback] = useState(!delay);
	useEffect(() => {
		let timeout;
		if (delay) {
			timeout = setTimeout(() => {
				setShowFallback(true);
			}, delay);
		}
		return () => {
			clearTimeout(timeout);
		};
	}, [delay]);

	return <F pastDelay={showFallback} />;
};

const Loadable = ({ loader, loading, delay }) => {
	const Component = lazy(loader);
	return props => (
		<Suspense fallback={<LoadableDelay fallback={loading} delay={delay} />}>
			<Component {...props} />
		</Suspense>
	);
};

export default Loadable;
